import { Toast } from 'primereact/toast';
import React, { useEffect, useRef } from 'react'
import { useHistory } from "react-router-dom";

export default function ValidateService({err,setErr}) {
    
    const toast = useRef(null);
    const history = useHistory();

    useEffect(() => {
        // console.log(err);
        if (err && err.response && err.response.data) {
            const {status ,message } = err.response.data;

            showMessages("error", `เกิดข้อผิดพลาด Status Code: ${status}`, `${message}`);
            if(status === 401){
                
                const interval = setInterval(() => {
                    history.push("/login");
                }, 3000);
                return () => clearInterval(interval);
            }
            setErr(null)

        }else if(err && err.text) {
            showMessages("error", `เกิดข้อผิดพลาด`, `${err.text}`);
            setErr(null)
            
        } else if(err !== null) {
            showMessages("error", `เกิดข้อผิดพลาด`, `ส่ง Parameterไม่ครบ หรือส่งค่าไม่ถูกต้อง`);
            setErr(null)
            
        } 
        
    }, [err])

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    return (
        <>
            <Toast ref={toast} position="top-right" style={{width :'auto'}}  />
        </>
    )
}
